import React, { FC, useState } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import Breadcrumbs from "../../shared/base-components/Breadcrumbs";
import StockList from "./StockList";

const StockPage: FC = () => {
  document.title = "Stok | Bu ekranda stok düzenleme işlerini yapabilirsiniz";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const [selectedCategory, setSelectedCategory] = useState<number>(0);

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          {selectedCategory === 0 ? (
            <Breadcrumbs title="Stok" breadcrumbItem="Stok Listesi" />
          ) : (
            <button
              type="button"
              title="Previous"
              aria-pressed="false"
              className="fc-prev-button btn btn-light-primary p-3"
              onClick={() => setSelectedCategory(0)}
            >
              <span className="fa fa-chevron-left"></span> Geri
            </button>
          )}

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <StockList
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default StockPage;
